<template>
  <v-app id="mainLayout">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in menu_items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
              link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
      <v-footer absolute>
      ver: 1.0.15 ({{this.ver}}) API:{{this.$store.getters.apiUrl}}
    </v-footer>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-4"
        @click="goToHome"
        
        
      >
        <span style="cursor: pointer" class="hidden-sm-and-down">{{this.$store.getters.pipUser}}</span>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>
      
      <v-btn icon @click.stop="dialogNotif = !dialogNotif">
        <v-badge
          v-model="showNotifBadge"
          color="red"
          v-bind:content="countNotifBadge"
        >
         <v-icon >mdi-apps</v-icon>
        </v-badge>
      </v-btn>
      <v-btn icon>
        <v-icon @click="logOut">mdi-door-open</v-icon>
      </v-btn>
   
    </v-app-bar>
    <v-main>
      <v-container
        fluid
      >
      <router-view />
  
      </v-container>
    </v-main>
    
    <v-footer app>
    </v-footer>

    <v-dialog v-model="dialogNotif" scrollable max-width="700px">
      <v-card>
        <v-card-title>Контроль залишків</v-card-title>
        <v-card-text >
          <v-simple-table
            fixed-header
            height="400px"
            dense
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ТМЦ</th>
                  <th class="text-left">На складі</th>
                  <th class="text-left">Має бути</th>
                  <th class="text-left">Залишок</th>
                  <th class="text-left">Не вистачає</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in notifList" :key="item.tmcid">
                  <td>{{ item.tmcname }}</td>
                  <td>{{ item.namesklad }}</td>
                  <td>{{ item.zal }}</td>
                  <td>{{ item.zalReal }}</td>
                  <td>{{ item.zalRiz }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogNotif = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    
    </v-dialog>
 
  </v-app>
</template>

<script>
  export default {
    data: () => ({
      drawer: null,
      menu_items: [],
      ver: '',
      dialogNotif: false,
      notifList: [],
    }),
    computed: {
      showNotifBadge: function () {
        if (this.notifList.length > 0) {
          return true
        } else {
          return false
        }
      },
      countNotifBadge: function () {
        return this.notifList.length
      },

    },
    methods: {
      logOut: function () {
        localStorage.pp = ''
        localStorage.pn = ''
        this.$router.push('/login')
      },
      goToHome: function () {
        this.$router.push('/').catch(()=>{})
      },
      nonifiGet() {
        return setTimeout(() => {
            this.apiNotifGet()
            this.nonifiGet()
          }, 120000)
      },
      apiNotifGet() {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: 34,
            ww: 5,
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.notifList = data.notifList
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          console.error('Error!', error)
          this.$router.push('/login').catch(()=>{})
        });

      },

    },
    created: function () {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          act: 9999,
          ww: 2,
          pp: localStorage.pp,
          pn: localStorage.pn,
        })
      };
      fetch(this.$store.getters.apiUrl, requestOptions)
      .then(async response => {
        const data = await response.json();
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        if (data.isauth == true) {
          this.menu_items = data.menu_items
          this.ver = data.ver
        }
        if (data.isauth == false) {
          this.$router.push('/login').catch(()=>{})
        }
      })
      .catch(error => {
        console.error('Error!', error)
        this.$router.push('/login').catch(()=>{})
      });
      this.apiNotifGet();
    },
    mounted() {
      this.nonifiGet();
    }
  }
</script>